import { hooks as userHooks } from 'App/ducks/userDuck';

export const useOrganizationShortName = () => {
  return userHooks.useOrganizationShortNameSelector();
};
